import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AdminAuthProvider } from "./contexts/AdminAuthContext";
import { initTikTokEvents } from "./lib/tiktokEvents";

// Import NATOMA components
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import ProjectSection from "./components/ProjectSection";
import FloorPlanSection from "./components/FloorPlanSection";
import VirtualTourSection from "./components/VirtualTourSection";
import PaymentSection from "./components/PaymentSection";
import ContactSection from "./components/ContactSection";

// Import RYAD components
import RyadHeader from "./components/ryad/RyadHeader";
import RyadHero from "./components/ryad/RyadHero";
import RyadProject from "./components/ryad/RyadProject";
import RyadFloorPlansSimple from "./components/ryad/RyadFloorPlansSimple";
import RyadAvailability from "./components/ryad/RyadAvailability";
import RyadVideo from "./components/ryad/RyadVideo";
import RyadPayment from "./components/ryad/RyadPayment";
import RyadSimulation from "./components/ryad/RyadSimulation";
import RyadContact from "./components/ryad/RyadContact";

// Admin
import AdminLogin from "./components/admin/AdminLogin";
import AdminDashboard from "./components/admin/AdminDashboard";
import AdminProtectedRoute from "./components/admin/AdminProtectedRoute";

const NatomaLandingPage = () => (
  <div className="min-h-screen bg-white">
    <Header />
    <HeroSection />
    <ProjectSection />
    <FloorPlanSection />
    <VirtualTourSection />
    <PaymentSection />
    <ContactSection />
  </div>
);

const RyadLandingPage = () => (
  <LanguageProvider>
    <div className="min-h-screen bg-white">
      <RyadHeader />
      <RyadHero />
      <RyadProject />
      <RyadFloorPlansSimple />
      <RyadAvailability />
      <RyadVideo />
      <RyadSimulation />
      <RyadPayment />
      <RyadContact />
    </div>
  </LanguageProvider>
);

function App() {
  useEffect(() => {
    initTikTokEvents();
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <AdminAuthProvider>
          <Routes>
            <Route path="/" element={<RyadLandingPage />} />
            <Route path="/natoma" element={<NatomaLandingPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <AdminProtectedRoute>
                  <AdminDashboard />
                </AdminProtectedRoute>
              }
            />
          </Routes>
        </AdminAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
